module.exports = __webpack_public_path__ + "img/NanoVerifyLogo.4d7903f9.png";